import { Component, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { UI_STRINGS } from '../../functions/language/uistrings';
import { ButtonComponent } from '../../modules/shared/ui-kit/buttons/button/button.component';
import { TranslateStringPipe } from '../../pipes/translate-string/translate-string.pipe';
import { CrossTabAuthService } from '../../services/cross-tab-auth/cross-tab-auth.service';

@Component({
  selector: 'cv-auth-overlay',
  imports: [TranslateStringPipe, ButtonComponent],
  templateUrl: './auth-overlay.component.html',
  styleUrl: './auth-overlay.component.scss',
})
export class AuthOverlayComponent {
  private readonly _authService = inject(CrossTabAuthService);
  private readonly _oidcService = inject(OidcSecurityService);

  readonly showOverlay = this._authService.showAuthOverlay;
  readonly STRINGS = UI_STRINGS.AUTH_OVERLAY;

  login() {
    this._oidcService.authorize();
  }

  handleBackdropClick(event: MouseEvent) {
    // Prevent closing when clicking the backdrop
    // Only the login button should dismiss the overlay
    event.stopPropagation();
  }
}
